import React from "react";
import {
  Box,
  Text,
  Image,
  VStack,
  HStack,
  Button,
  Stack,
  IconButton,
  Heading,
} from "@chakra-ui/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import Card from "./Card";
import bg from "../../../assets/home/bgimg.png";
import servicesTag from "../../../assets/home/card1.png";
import teaKettle from "../../../assets/home/card9.png";
import strategyIcon from "../../../assets/home/card10.png";
import handPointer from "../../../assets/home/handpointer.png";
import applicationImg from "../../../assets/home/hero/card/redcard.png";
import lightgreen from "../../../assets/home/hero/card/bluecard.png";
import gray from "../../../assets/home/hero/card/brown.png";
import email from "../../../assets/home/hero/email.png";
import content from "../../../assets/home/hero/content.png";
import ppc from "../../../assets/home/hero/ppc.png";
import seo from "../../../assets/home/hero/seo.png";
import social from "../../../assets/home/hero/social.png";
import appandweb from "../../../assets/home/hero/appandweb.png";
import yellowcard from "../../../assets/home/hero/card/yellow.png";
import flowerImage from "../../../assets/home/flowerr.png";

const Whatwedo = () => {
  const partner = [
    
    {
      title: " Branding & Identity ",
      sorttitle: "In Conversation with",
      description: "We craft unique brand stories, logos, and visual identities that leave a lasting impression.",
      shortdescription: "",
      image: lightgreen,
      cardicon:ppc
    },
    {
      title: "Email Marketing",
      sorttitle: "In Conversation with",
      description: "Personalized email strategies that nurture leads and drive sales.",
      shortdescription: "FRONT LAWN",
      image: gray,
      cardicon:email
    },
   
    {
      title: "Search Engine Optimization (SEO) ",
      description: "Boost your visibility on Google and attract the right audience effortlessly.",
      image: yellowcard,
      cardicon:seo
    },
    {
      title: "Pay-Per-Click (PPC) Advertising",
      description: "Smart ad strategies to maximize conversions and ROI.",
      image: lightgreen,
      cardicon:ppc
    },
    {
      title: " App & Web Development   ",
      description: "Stunning, high-performing websites and apps that captivate users and drive growth.",
      image: applicationImg,
      cardicon:appandweb
    },
    {
      title: "Social Media Marketing ",
      description: "Powerful campaigns that enhance your brand’s presence and engagement.",
      image: yellowcard,
      cardicon:social
    },
    {
      title: "Content Marketing",
      description: "Engaging content that connects with your audience and builds trust.",
      image: applicationImg,
      cardicon:content
    },
  
  ];

  return (
    <Box
      w="100%"
      px={{ base: 4, md: 16 }}
      py={{ base: 12, md: 24 }}
      overflow="hidden"
      position="relative"
      justifyContent="center"
      alignItems="center"
      bgColor={"#F4EDDC"}
    >

    <Box
    position="absolute"
    top={0}
    left={0}
    w="100%"
    h="100%"
    bgImage={`url(${bg})`}
    bgSize="cover"
    bgPosition="center"
    opacity={0.8}
    zIndex={0}
  />
      <HStack
        justifyContent="center"
        alignItems="center"
        spacing={0}
        textAlign="center"
        position="relative"
        zIndex={2}
        pb={{ base: 4, md: 16 }}
      >
        <Box textAlign="center" position="relative">
          {/* Flower image behind heading */}
          <Image
            src={flowerImage}
            alt="Flower"
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
            boxSize={{ base: "80px", md: "140px" }}
            opacity={1}
            zIndex={0}
          />
          <Box
            display={"flex"}
            width={"500px"}
            justifyContent="flex-end"
            alignItems="center"
            mb={4}
            flexDirection={"row"}
          >
            <Heading
              as="h2"
              fontSize={{ base: "2xl", md: "4xl" }}
              fontWeight="bold"
              zIndex={1}
              position="relative"
              className="fade-in-up"
            >
              Our{" "}
              <Text
                as="span"
                fontStyle="italic"
                color="#005770"
                className="fade-in-up"
              >
                Services
              </Text>
              ,
            </Heading>
            <Image src={servicesTag} alt="Services Tag" maxW="150px" />
          </Box>
        </Box>
      </HStack>

      {/* Swiper Carousel */}
      <Box px={4}  position="relative" >
        <Swiper
          slidesPerView={1}
          spaceBetween={20}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          loop={true}
          autoplay={{ delay: 3000 }}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          modules={[Navigation, Autoplay]}
          centeredSlides={true}
        >
          {partner.map((service, index) => (
            <SwiperSlide style={{overflow:"visible"}} key={index}>
              <Box display="flex" justifyContent="center" className="card-wrapper">
                <Card service={service} index={index}  cardwidth="80%" />
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Navigation Buttons */}
        <IconButton
          className="swiper-button-prev"
          position="absolute"
          left="0"
          top="50%"
          transform="translateY(-50%)"
          aria-label="Previous"
          // icon={<ArrowBackIcon boxSize={8} />}
          zIndex={2}
          bg="#F4EDDC" 
          _hover="#F4EDDC"
        />
        <IconButton
          className="swiper-button-next"
          position="absolute"
          right="0"
          top="50%"
          transform="translateY(-50%)"
          aria-label="Next"
          // icon={<ArrowForwardIcon boxSize={8} />}
          zIndex={2}
          bg="#F4EDDC"
          _hover="#F4EDDC"
        />
      </Box>

      {/* What We Do Section */}
      <VStack mt={{ base: 16, md: 24 }} spacing={6}>
        <HStack spacing={4} align="center" className="fade-in-up">
          <Text
            fontSize={{ base: "2xl", md: "4xl" }}
            fontWeight="bold"
            className="fade-in-up"
          >
            What We{" "}
            <Text as="span" color="#BFA585" className="fade-in-up">
              Do
            </Text>
          </Text>
          <Image
            src={teaKettle}
            alt="Tea Kettle"
            maxW="40px"
            data-animated="true"
            className="fade-in-up"
          />
        </HStack>
      </VStack>

      {/* Description */}
      <Stack
        direction={{ base: "column", md: "row" }}
        spacing={12}
        mt={12}
        px={8}
        align="center"
        justify="center"
      >
        <VStack spacing={3} align="center" flexShrink={0}>
          <Image
            src={strategyIcon}
            alt="Strategy Icon"
            boxSize="70px"
            data-animated="true"
          />
          <Text
            fontWeight="bold"
            fontSize="md"
            textAlign="center"
            className="fade-in-up"
          >
            Innovative Digital Strategies
          </Text>
        </VStack>
        <Box w="100%" display="flex" justifyContent="center">
          <VStack
            spacing={4}
            maxW="700px"
            textAlign="start"
            align="start"
            className="fade-in-up"
            ml={{ base: "0", md: "-190px" }}
          >
            <Text
              fontSize={{ base: "xl", md: "2xl" }}
              fontWeight="bold"
              className="fade-in-up"
            >
              We don’t follow trends —{" "}
              <Text
                as="span"
                fontStyle="italic"
                color="#BFA585"
                fontWeight="semibold"
                className="fade-in-up"
              >
                we create them!
              </Text>
            </Text>
            <Text fontSize="sm" className="fade-in-up">
              Our strategies are built on data, creativity, and technology to
              help your brand stand out.
            </Text>
            <Text fontSize="sm" className="fade-in-up">
            ✅ Customized Approach – No generic plans, only tailor-made solutions.
            </Text>
            <Text fontSize="sm" className="fade-in-up">
            ✅ Tech-Driven Execution – AI, automation, and the latest tools for maximum impact.
            </Text>
            <Text fontSize="sm" className="fade-in-up">
            ✅ Growth-Focused – Every strategy is designed to increase engagement, leads, and revenue.
            </Text>
            <Text
              fontSize={{ base: "xl", md: "xl" }}
              fontWeight="bold"
              className="fade-in-up"
              mt={8}
              ml={8}
            >
               With DoggleIndia, you don’t just compete,{" "}
              <Text
                as="span"
                fontStyle="italic"
                color="#BFA585"
                fontWeight="semibold"
                className="fade-in-up"
              >
                you lead!
              </Text>
            </Text>
          </VStack>
        </Box>
      </Stack>

      {/* CTA Button */}
      <VStack mt={12} spacing={4} align="center">
        <Box position="relative" className="fade-in-up">
          <Button
            colorScheme="teal"
            bg="#005a7e"
            color="white"
            px={8}
            py={6}
            borderRadius="xl"
            fontWeight="semibold"
            _hover={{ bg: "#007ca6" }}
          >
            Let’s Build Your Brand
          </Button>
          <Image
            src={handPointer}
            alt="Hand Pointer"
            boxSize={{ base: "25px", md: "30px" }}
            position="absolute"
            right={{ base: "-2", md: "-4" }}
            bottom={{ base: "-2", md: "-4" }}
          />
        </Box>
      </VStack>
    </Box>
  );
};

export default Whatwedo;
